import React from 'react';
import moment from 'moment';

import { MCButton, TextAreaField, TextField } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { getSelectLabel, lang, permissions, remCss } from 'src/helpers';

import constants from 'src/constants';

import { STEPS } from './constants';
import LANG_CONST from 'src/helpers/lang/const';

export class BookInfo extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get accountModel() {
    return this.props.accountModel;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
  }

  inputAnswers = (index) => (n, v) => {
    this.model.resetApiState(this.model.state.saveApi);
    const { handleChange } = this.model;
    const { answers } = this.model.state;
    const old = [...answers];
    old[index]['answer'] = v;

    handleChange('answers', [...old]);
  };
  add = (event) => {
    event.preventDefault();
    this.model.createAppointment((err, res, success) => {
      let invoiceId = res?.invoice?.id;
      if (success) {
        if (this.config.payNowEnabled && this.model.state.payNow && invoiceId) {
          setTimeout(() => this.navigate('/invoices/payment/' + invoiceId), 0);
        } else {
          if (this.props.onDone) this.props.onDone();
          else this.navigate(permissions.PAGES.APPOINTMENTS_PAGE.path);
        }
      } else if (err === 'DEACTIVATED_DOCTOR') {
        this.model.checkDisabledDoctor({
          ...model.state.doctor,
          status: constants.general.userStatus.disabled
        });
        this.props.onBack();
      } else if (err === 'DEACTIVATED_ACCOUNT') {
        this.model.emit('checkDisabledAccount', this.model.state.user);
        this.props.onBack();
      }
    });
  };

  render = () => {
    const { invalid, errorMessage, error, loading } = this.model.getApiState(this.model.state.saveApi);
    const slot = this.model.state.selectedSlot;
    const { selectedType, doctor, answers } = this.model.getState();
    const fees = this.model.getFees();
    const currency = this.model.getCurrency();

    return (
      <div className={'mc-tab-content ' + (this.model.state.step === STEPS.INFO ? '' : 'mc-inactive')}>
        {slot && (
          <div className={'mc-flex mc-grow'} style={{ overflow: 'auto' }}>
            <div className={'mc-container-content__body-left'}>
              <div className={'mc-label'}>{lang.t('Date')}</div>
              <div className={'mc-value'}>{moment(slot.startDate).format('MMMM DD, yyyy')}</div>
              <div className={'mc-label'}>{lang.t('Time')}</div>
              <div className={'mc-value'}>{moment(slot.startDate).format('hh:mm a')}</div>
              <div className={'mc-label'}>{lang.t('Treatments prefer')}</div>
              <div className={'mc-value'}>
                {getSelectLabel(constants.general.appointment_types, selectedType)}
              </div>
              {selectedType === 'in_office' && (
                <div className={'mc-grow mc-flex-col'}>
                  {slot?.hospital.split('\n').map((txt, i) => (
                    <div className={i === 0 ? ' mc-note-2' : ''} key={i}>
                      {i === 0 ? txt.split('_')[0] : txt}
                    </div>
                  ))}
                </div>
              )}
              <div className={'mc-value'}></div>
              <div className={'mc-label'}>{lang.t('Payment')}</div>
              <div className={'mc-value'}>
                {selectedType === 'virtual' ? fees?.virtual : fees?.office} {currency}
              </div>
            </div>
            <div className={'mc-container-content__body-center'}>
              <div className={'mc-flex-20-col'}>
                {!['DEACTIVATED_DOCTOR', 'DEACTIVATED_ACCOUNT'].includes(error) && errorMessage && (
                  <p className='mc-error'>{errorMessage}</p>
                )}
                <TextField
                  template={6}
                  name={'disease'}
                  label={'Disease'}
                  placeholder={'Fever'}
                  value={this.model.input('disease')}
                  onChange={(n, v) => {
                    this.model.resetApiState(this.model.state.saveApi);
                    this.model.handleChange(n, v);
                  }}
                  onBlur={this.model.handleBlur}
                  invalid={invalid}
                />
                <TextAreaField
                  template={6}
                  name={'symptoms'}
                  label={'Symptoms'}
                  placeholder={'Write your symptoms here'}
                  value={this.model.input('symptoms')}
                  onChange={(n, v) => {
                    this.model.resetApiState(this.model.state.saveApi);
                    this.model.handleChange(n, v);
                  }}
                  rows={2}
                  onBlur={this.model.handleBlur}
                  invalid={invalid}
                />
                {!!doctor.questions?.length && (
                  <div className={'mc-note-2'}>{lang.t('Question')}</div>
                )}
                {answers?.map((answers, i) => (
                  <div className={'mc-flex-col'} key={i} style={{ marginTop: remCss(-5) }}>
                    <div className={'mc-note-text'}>{lang.t(answers.question)}</div>
                    <TextAreaField
                      template={6}
                      rows={2}
                      name={'answer_' + i}
                      placeholder={'Answer here'}
                      value={answers?.answer}
                      onChange={this.inputAnswers(i)}
                      onBlur={this.model.handleBlur}
                      invalid={invalid?.answers || {}}
                      errorName={'Answer'}
                    />
                  </div>
                ))}
                <div className={'mc-note-2'}>{lang.t('Photos / Files')}</div>
                <MediaDropBox
                  style={{ marginTop: remCss(-15) }}
                  name={'files'}
                  multi={true}
                  onChange={(n, v) => {
                    this.model.resetApiState(this.model.state.saveApi);
                    this.model.handleChange(n, v);
                  }}
                  value={this.model.input('files') !== '' ? this.model.input('files') : []}
                  invalid={invalid}
                />
              </div>
            </div>
          </div>
        )}
        <div className={'mc-flex-20'}>
          {this.model.state.historySteps.length && (
            <MCButton
              light
              primary
              radius
              medium
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                this.model.previousStep();
              }}
              style={{ width: remCss(100) }}
              label={LANG_CONST.buttons.back}
            />
          )}
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.cancel}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.save}
            style={{ width: remCss(100) }}
            disabled={loading}
            loading={loading}
            onClick={this.add}
          />
        </div>
      </div>
    );
  };
}
